import type { QueryFunction, QueryKey, QueryMeta } from '@tanstack/react-query';
import { createContext } from 'react';

export type QueryExecution = <T>(
  queryFn: QueryFunction<T, QueryKey>,
  meta?: QueryMeta,
) => { queryFn: QueryFunction<T, QueryKey>; meta?: QueryMeta };

// Platform providers may adapt execution without taking cache or realtime
// ownership. With no provider, shared hooks keep their canonical options.
export const QueryExecutionContext = createContext<QueryExecution | null>(null);
